// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { AccountTradeStatus } from './AccountTradeStatus';
import { StopTradingReason } from './StopTradingReason';
import { StringUtils } from '../StringUtils';
class _AccountTradeStatusHelper {
    GetLocalizedTradingStatus(status, reason) {
        const statusKey = this.getCurrentTradingStatusLocalKey(status);
        let result = statusKey ? Resources.getResource(statusKey) : '';
        if (status === AccountTradeStatus.TRADING_DISABLED_RISK_STATUS) {
            const reasonKey = this.getStopTradingReasonLocalKey(reason);
            const reasonLocalized = reasonKey ? Resources.getResource(reasonKey) : '';
            if (!result) {
                result = reasonLocalized;
            }
            else if (reasonLocalized !== StringUtils.THREE_DASHES) {
                result += ' : ' + reasonLocalized;
            }
            else {
                result = Resources.getResource('panel.accounts.accountDetails.RiskManagement.TradingStatus.Disabled by risk rules');
            }
        }
        return result;
    }
    getCurrentTradingStatusLocalKey(status) {
        switch (status) {
            case AccountTradeStatus.ACTIVE_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Active';
            case AccountTradeStatus.CLOSED_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Closed';
            case AccountTradeStatus.SUSPEND_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Suspend';
            case AccountTradeStatus.TRADING_DISABLED_RISK_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Auto closed';
            case AccountTradeStatus.FINRA_DAY_TRADER_PATTERN_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.FinraDayTraderStatus';
            case AccountTradeStatus.LIQUIDATION_ONLY_STATUS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.LiquidationOnlyStatus';
            // case AccountTradeStatus.?
            //     return 'panel.accounts.accountDetails.RiskManagement.Trading.Order Flow Limit(per day)';
            default:
                return '';
        }
    }
    getStopTradingReasonLocalKey(reason) {
        switch (reason) {
            case StopTradingReason.MAX_LOSS:
                return 'panel.accounts.accountDetails.RiskManagement.Trading.Daily loss limit reached';
            case StopTradingReason.MAX_DAY_VOL:
                return 'panel.accounts.accountDetails.RiskManagement.Trading.Max day volume reached';
            case StopTradingReason.WEEKLY_LOST_LIMIT:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Weekly lost limit reached';
            case StopTradingReason.TRAILING_DRAWDOWN_LIMIT:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Max trailing drawdown was reached';
            case StopTradingReason.MAX_UNREALIZED_LOSS:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Unrealized loss limit reached';
            case StopTradingReason.MAX_ORDERS_COUNT_PER_DAY:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Disabled by risk rules.maxOrdersPerDay';
            case StopTradingReason.RELATIVE_DRAWDOWN_LEVEL:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Max relative drawdown level was reached';
            case StopTradingReason.EOD_TRAILING_DRAWDOWN:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.EOD trailing drawdown level was reached';
            case StopTradingReason.RELATIVE_DAILY_LOSS_LIMIT:
                return 'panel.accounts.accountDetails.RiskManagement.TradingStatus.Relative daily loss limit was reached';
            case StopTradingReason.MAX_DAILY_PROFIT:
                return 'RiskManagement.Messages.MaxDailyProfit';
            default:
                return StringUtils.THREE_DASHES;
        }
    }
}
export const AccountTradeStatusHelper = new _AccountTradeStatusHelper();
